import multiPartParser from './multipart-parser'
import binaryFileConverter from './binary-file-converter'
import moment from 'moment'
import {parse} from 'json2csv'

const getDateFormat = moment(Date()).format('YYYYMMDD')

export default (data) => (type = 'exports', props = {}) => {
  let allParts = {}
  const {portfolioName, title} = props
  if (type === 'exportNotifications' && data.length > 0) {
    allParts.body = parse(data)
    allParts.fileName = `${getDateFormat}-${title}-${portfolioName}.csv`
    allParts.fileType = 'application/csv'
  } else {
    allParts = multiPartParser(data)
    const byteArrays = binaryFileConverter(allParts.body)
    allParts.body = byteArrays
  }
  let {body, fileName, fileType} = allParts
  // reverted logic to support only csv
  let blob = new Blob(
    (type === 'exportNotifications') ? [body] : body,
    {type: fileType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
  )

  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, fileName)
  } else {
    let blobURL = window.URL.createObjectURL(blob)
    let tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    tempLink.href = blobURL
    tempLink.setAttribute('download', fileName)

    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank')
    }

    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
    window.URL.revokeObjectURL(blobURL)
  }
  return true
}



// WEBPACK FOOTER //
// ./src/file-downloader.js